import React from 'react';
import { Link } from 'react-router-dom';
import MobileMenu from '../MobileMenu/MobileMenu';

const Header = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  return (
    <header id='header'>
      <div className={'' + props.hclass}>
        <nav className='navigation navbar navbar-expand-lg navbar-light'>
          <div className='container-fluid'>
            <div className='row align-items-center'>
              <div className='col-lg-3 col-md-3 col-3 d-lg-none dl-block'>
                <MobileMenu />
              </div>
              <div className='col-lg-2 col-md-6 col-6'>
                <div className='navbar-header'>
                  <Link onClick={ClickHandler} className='navbar-brand' to='/'>
                    <img src={props.Logo} alt='' />
                  </Link>
                </div>
              </div>
              <div className='col-lg-7 col-md-1 col-1'>
                <div
                  id='navbar'
                  className='collapse navbar-collapse navigation-holder'
                >
                  <button className='menu-close'>
                    <i className='ti-close'></i>
                  </button>
                  <ul className='nav navbar-nav mb-2 mb-lg-0'>
                    <li>
                      <Link onClick={ClickHandler} to='/'>
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link onClick={ClickHandler} to='/about'>
                        About
                      </Link>
                    </li>
                    <li className='menu-item-has-children'>
                      <Link onClick={ClickHandler} to='/services'>
                        Services
                      </Link>
                      <ul className='sub-menu'>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to='/services/air-freight'
                          >
                            Air Freight
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to='/services/road-freight'
                          >
                            Road Freight
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to='/services/ocean-freight'
                          >
                            Ocean Freight
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={ClickHandler}
                            to='/services/warehousing'
                          >
                            Warehousing
                          </Link>
                        </li>
                      </ul>
                    </li>
                    {/* <li><Link onClick={ClickHandler} to="/tracking">Tracking</Link></li> */}
                    <li>
                      <Link onClick={ClickHandler} to='/contact'>
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='col-lg-3 col-md-2 col-2'>
                <div className='header-right'>
                  <div className='close-form'>
                    <Link
                      onClick={ClickHandler}
                      className='theme-btn'
                      to='/tracking'
                    >
                      Track Shipment <i className='flaticon-next'></i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};
export default Header;
